module.exports = __webpack_public_path__ + "media/images/level_introduction3-bd160132f30abc79c86df2a9fcb65f77.png";